import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  fetchProfile,
  updateProfile,
  type ProfileResponse,
  type ProfileUpdateRequest,
} from "../services/profile";

export const profileKeys = {
  root: ["profile"] as const,
  current: () => [...profileKeys.root, "current"] as const,
};

export const useProfile = () => {
  return useQuery(profileKeys.current(), () => fetchProfile());
};

export const useUpdateProfile = () => {
  const client = useQueryClient();
  return useMutation(
    (data: ProfileUpdateRequest) => updateProfile(data),
    {
      onSuccess: () => {
        client.invalidateQueries({ queryKey: profileKeys.current() });
      },
    }
  );
};

